const MS_PER_DAY = 86400000;

export const EXPIRY_COLORS = {
    none: "#64748b",
    ok: "#059669",
    warning: "#D97706",
    critical: "#DC2626",
};

export function parseValidityDate(value) {
    if (!value) return null;
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
}

function startOfDay(date) {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
}

/** Jours restants (0 = aujourd'hui, négatif = expiré). */
export function daysUntilExpiry(value) {
    const target = parseValidityDate(value);
    if (!target) return null;
    const today = startOfDay(new Date());
    return Math.ceil((startOfDay(target) - today) / MS_PER_DAY);
}

/**
 * Couleur selon l'urgence : vert (OK), orange (< 30 j), rouge (< 7 j ou expiré).
 */
export function getExpiryColor(value, { warningDays = 30, criticalDays = 7 } = {}) {
    if (!value) return EXPIRY_COLORS.none;
    const days = daysUntilExpiry(value);
    if (days == null) return EXPIRY_COLORS.none;
    if (days < 0 || days <= criticalDays) return EXPIRY_COLORS.critical;
    if (days <= warningDays) return EXPIRY_COLORS.warning;
    return EXPIRY_COLORS.ok;
}

export function formatValidityDate(value) {
    const d = parseValidityDate(value);
    return d ? d.toLocaleDateString("fr-FR") : "–";
}

/**
 * Chaque mouvement EARN peut avoir sa propre expires_at.
 * On affiche la prochaine échéance + le détail si plusieurs lots.
 */
export function summarizePointsValidity(movements = [], fallbackDate = null) {
    const today = startOfDay(new Date());
    const lotsByDate = new Map();

    (Array.isArray(movements) ? movements : []).forEach((m) => {
        if (!m?.expires_at || Number(m.points) <= 0) return;
        const type = String(m.type || "").toUpperCase();
        if (type !== "EARN" && type !== "ADJUST") return;
        const key = String(m.expires_at).slice(0, 10);
        lotsByDate.set(key, (lotsByDate.get(key) || 0) + Number(m.points));
    });

    const lots = [...lotsByDate.entries()]
        .map(([dateKey, points]) => ({
            dateKey,
            date: parseValidityDate(dateKey),
            points,
        }))
        .filter((lot) => lot.date && startOfDay(lot.date) >= today)
        .sort((a, b) => a.date - b.date);

    if (lots.length > 0) {
        const nearest = lots[0];
        return {
            displayDate: nearest.date,
            lots,
            multiple: lots.length > 1,
            hint: lots.length > 1
                ? `Prochaine échéance · ${lots.length} lots de points avec des dates différentes`
                : `${nearest.points} pt${nearest.points > 1 ? "s" : ""} concerné${nearest.points > 1 ? "s" : ""} à cette date`,
            source: "movements",
        };
    }

    const fallback = parseValidityDate(fallbackDate);
    if (fallback) {
        return {
            displayDate: fallback,
            lots: [],
            multiple: false,
            hint: "Date indicative (aucune échéance détaillée dans l'historique des mouvements)",
            source: "fallback",
        };
    }

    return {
        displayDate: null,
        lots: [],
        multiple: false,
        hint: "Aucune date de validité enregistrée",
        source: "none",
    };
}
